import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { MessageService } from '../../services/message.service';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderService } from '../../services/cardholder.service';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';

@Component({
  selector: 'app-personal-forms-upload',
  templateUrl: './forms-upload.component.html',
  styleUrls: ['./forms-upload.component.css']
})
export class FormsUploadComponent implements OnInit, OnChanges {
  @Input() profileSearchResult: ProfileSearchResult;
  @Output() newFormUploaded = new EventEmitter<void>();
  subview: string;
  searchResults: ProfileSearchResult;

  constructor(
    private entitlementService: EntitlementService,
    private messageService: MessageService,
    private cardholderService: CardholderService
  ) {}

  ngOnInit() {
    this.searchFormsCardholders();
  }

  ngOnChanges() {
    this.searchFormsCardholders();
  }

  onNewFormUploaded() {
    this.newFormUploaded.emit();
  }

  searchFormsCardholders() {
    this.searchResults = this.profileSearchResult;
    this.subview = 'results';
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
